import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03934195"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "consultations py-12 px-8" }
const _hoisted_2 = {
  key: 0,
  class: "scroll-component-container"
}
const _hoisted_3 = { class: "scroll-component" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "date text-dark fw-bold" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 1,
  class: "icon icon-user-circle me-8",
  title: "En persona"
}
const _hoisted_8 = {
  key: 0,
  class: "text-primary fw-bold"
}
const _hoisted_9 = { class: "text-ternary fw-bold" }
const _hoisted_10 = { class: "d-flex justify-content-between" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-expand-right text-sm align-self-center ms-4",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.consultations.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultations, (consultation, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card item py-12 px-16 mb-8",
                key: index
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$str.formatDateTime(consultation.initDate)), 1),
                  _createElementVNode("div", null, [
                    (consultation.via === 'phone' || consultation.via === 'videocall')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "icon icon-phone me-8",
                          title: consultation.via === 'phone' ? 'Teléfono' : 'Videollamada'
                        }, null, 8, _hoisted_6))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Consulta')), 1)
                  ])
                ]),
                (!!_ctx.showProfessional && !!consultation.expedient.professional)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(consultation.expedient.professional.name) + " " + _toDisplayString(consultation.expedient.professional.surname), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, _toDisplayString(!!consultation.clinic ? consultation.clinic.name : _ctx.$t('- Sin clínica asociada -')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.type(consultation)), 1),
                  (_ctx.can('patient.expedient.show') && !!_ctx.goShowConsultation)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {name: 'patient.expedient.show',
                  params: {
                    expedient:  consultation.expedientId,
                    tabName: 'consultas',
                    treatment: _ctx.$route.params.treatment,
                    consultation: consultation.id,
                  },
                  query: {
                    tratamiento: _ctx.currentTreatment?.id,
                  }},
                        class: "btn btn-icon btn-sm text-primary p-0 justify-content-center",
                        "aria-label": this.$t('Ver consulta'),
                        onClick: ($event: any) => (_ctx.setConsultation(consultation))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Ver consulta')) + " ", 1),
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["to", "aria-label", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('No tienes ninguna consulta')), 1))
  ]))
}